export default {"src":"/_next/static/media/organize-banquets-icon.b6df8138.svg","height":125,"width":140,"blurWidth":0,"blurHeight":0};